/**
 * CV Configuration
 * Personaliza aquí los colores, fuentes y estilos del CV
 * Esta configuración permite que cualquier persona adapte el CV a su marca personal
 */

export const cvConfig = {
    // Información personal - Se obtendrá dinámicamente desde la API
    // Los social_links con is_visible=false contienen los datos de contacto
    personalInfo: {
        phone: null, // Se obtendrá de social_links donde name="Phone"
        website: null, // Se obtendrá de social_links donde name="Website"
        email: null, // Se obtendrá de social_links donde name="Email"
    },

    // Colores principales - Paleta profesional y elegante
    colors: {
        primary: "#1e3a8a", // Azul navy (muy oscuro y elegante)
        secondary: "#475569", // Gris medio
        accent: "#0891b2", // Cyan para acentos
        text: "#1e293b", // Gris muy oscuro para texto
        textLight: "#64748b", // Gris claro para texto secundario
        background: "#ffffff", // Fondo blanco
        sectionBg: "#f1f5f9", // Fondo de secciones (gris azulado claro)
        headerBg: "#f8fafc", // Fondo del header
        border: "#cbd5e1", // Color de bordes
        skillTag: "#dbeafe", // Fondo de tags de habilidades (azul muy claro)
    },

    // Fuentes
    fonts: {
        main: "Helvetica",
        bold: "Helvetica-Bold",
        size: {
            h1: 26,
            h2: 13,
            h3: 11,
            body: 10,
            small: 9,
        },
    },

    // Espaciados
    spacing: {
        pageMargin: 40,
        sectionGap: 18,
        itemGap: 12,
        lineHeight: 1.4,
    },

    // Configuración de secciones (activa/desactiva secciones del CV)
    sections: {
        about: true,
        experience: true,
        projects: true,
        skills: true,
        certifications: true,
        education: false,
    },

    // Información adicional del CV
    footer: {
        show: true,
        text: "Generado automáticamente desde mi portfolio web",
    },

    // Límites de contenido (para evitar CVs demasiado largos)
    limits: {
        maxProjects: 6, // Máximo de proyectos a mostrar
        maxExperiences: 10, // Máximo de experiencias
        descriptionLength: 900, // Máximo de caracteres en descripciones
    },
};
